module.exports = __webpack_public_path__ + "media/images/emblems/Brusio_wappen-64dc908fce9454ebae2de8f2804bb916.svg";